import { useCallback, useEffect, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
export const blogUrl = (path) => `${BASE}/api/blog/${path}`;

export function useBlogFeed() {
  const [posts, setPosts] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = useCallback(async (nextOffset = 0, signal) => {
    setLoading(true); setError("");
    try {
      const response = await fetch(blogUrl(`feed?limit=24&offset=${nextOffset}`), { cache: "no-store", signal });
      if (!response.ok) throw new Error("Latest articles couldn't be loaded. Please retry.");
      const data = await response.json();
      if (!Array.isArray(data.posts)) throw new Error("The blog feed returned an unexpected response.");
      setPosts((previous) => [...new Map([...(nextOffset ? previous : []), ...data.posts].map((post) => [post.slug, post])).values()]);
      setOffset(nextOffset + data.posts.length); setHasMore(Boolean(data.has_more));
    } catch (e) { if (e.name !== "AbortError") setError(e.message); }
    finally { if (!signal?.aborted) setLoading(false); }
  }, []);
  useEffect(() => { const controller = new AbortController(); load(0, controller.signal); return () => controller.abort(); }, [load]);
  return { posts, loading, error, hasMore, loadMore: () => load(offset), retry: () => load(offset) };
}